import styled, { css } from 'styled-components'
import Flex from 'Components/Flex'
import ShowMore from 'Layout/ShowMore'
import { BREAK_POINT_SM } from '@CSSVars/variables'
import { GREY_BACKGROUND, OUTLINE_COLOR, FONT_BASE_COLOR } from '@CSSVars/colors'

export const filterCss = css`
  background-color: ${GREY_BACKGROUND};
  border: 1px solid ${OUTLINE_COLOR};
  padding: 16px 16px 12px 16px;
  margin-bottom: 12px;
  display: block !important;
  border-radius: 10px;
  svg {
    margin-right: 10px;
    fill: ${FONT_BASE_COLOR};
    &:hover {
      cursor: pointer;
    }
  }
  a {
    vertical-align: middle;
    margin-top: -1px;
  }
  a, div {
    display: inline-block;
    white-space: nowrap;
    line-height: 22px;
  }
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    a, div {
      white-space: initial;
    }
  }

`

export const _FilterBarFlex = styled(Flex)`
  ${filterCss}
`
export const _Divider = styled.div`
  padding: 0 12px;
  color: ${OUTLINE_COLOR};

`

export const _IconContainer = styled.div`
  &:hover {
    cursor: pointer;
  }
`

export const _ShowMore = styled(ShowMore)`
  margin-top: 0;
  width: auto;
  padding-left: 12px;
  position: relative;

`
